(function () {
  var queued = false;

  function label(fs) {
    var lg = fs.querySelector('legend');
    if (!lg) return null;
    var name = (lg.childNodes[0] && lg.childNodes[0].textContent || '').trim().toLowerCase();
    if (name !== 'colore') return null;
    var s = lg.querySelector('.vpdc-selected-value');
    if (!s) {
      s = document.createElement('span');
      s.className = 'vpdc-selected-value';
      lg.insertBefore(s, lg.childNodes[1] || null);
    }
    return s;
  }

  function sync(fs) {
    var s = label(fs);
    if (!s) return;
    var c = fs.querySelector('input:checked');
    if (!c) return;
    var next = ': ' + (c.getAttribute('data-color') || c.value || '');
    if (s.textContent !== next) s.textContent = next;
  }

  function all() {
    document.querySelectorAll('fieldset.product-options').forEach(sync);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      all();
    });
  }

  document.addEventListener('change', function (e) {
    var fs = e.target.closest && e.target.closest('fieldset.product-options');
    if (fs) sync(fs);
  }, true);

  document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);

  function watch() {
    if (!document.body) return setTimeout(watch, 50);
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
    all();
  }

  watch();
})();